<template>
    <div>
        <el-form label-width="70px" :label-position="'right'">
            <el-form-item label="折扣">
                <el-input-number v-model="$parentInfo.studentCart.dialog_DiscountCourse.discountFilter.discount"
                                 size="medium" type="number"
                                 :min="1" :max="10" :step="0.5"></el-input-number>
            </el-form-item>
<!--            <el-form-item label="试听课时">-->
<!--                <el-input-number-->
<!--                        v-model="$parentInfo.studentCart.dialog_DiscountCourse.discountFilter.possible_auditions_period"-->
<!--                        size="medium" type="number"-->
<!--                        :min="0"></el-input-number>-->
<!--            </el-form-item>-->
            <el-form-item label="折扣原因">
                <el-input v-model="$parentInfo.studentCart.dialog_DiscountCourse.discountFilter.discount_reason" size="small"
                          type="textarea"></el-input>
            </el-form-item>
        </el-form>
        <div class=" text-right">
            <el-button type="primary" size="small" @click="handleChangeDiscount()"
                       :loading="$parentInfo.studentCart.dialog_DiscountCourse.button_loading">确 定
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleMessage();
        },
        methods: {
            handleMessage() {
                this.$parentInfo.studentCart.dialog_DiscountCourse.discountFilter.discount = this.$store.state.modal.data.discount;
                this.$parentInfo.studentCart.dialog_DiscountCourse.discountFilter.giving_period = this.$store.state.modal.data.giving_period;
                this.$parentInfo.studentCart.dialog_DiscountCourse.discountFilter.discount_reason = this.$store.state.modal.data.discount_reason;
                this.$parentInfo.studentCart.dialog_DiscountCourse.discountFilter.possible_auditions_period = this.$store.state.modal.data.possible_auditions_period;
                this.loading = false
            },
            // 优惠
            handleChangeDiscount() {
                this.$parentInfo.studentCart.dialog_DiscountCourse.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'changeDiscount', {
                    'cart_id': this.$store.state.modal.data.cart_id,
                    'discount': this.$parentInfo.studentCart.dialog_DiscountCourse.discountFilter.discount,
                    'giving_period': this.$parentInfo.studentCart.dialog_DiscountCourse.discountFilter.giving_period,
                    'discount_reason': this.$parentInfo.studentCart.dialog_DiscountCourse.discountFilter.discount_reason != null ? this.$parentInfo.studentCart.dialog_DiscountCourse.discountFilter.discount_reason : '无',
                    'possible_auditions_period': this.$parentInfo.studentCart.dialog_DiscountCourse.discountFilter.possible_auditions_period,
                });
            },
        }
    };
</script>

<style scoped>
</style>
